module.exports = __webpack_public_path__ + "img/art-img.ee9a12bd.png";